import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const NavigationBarFilmIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 20"
    sx={{ width: '20px', height: '20px', ...sx }}
    {...props}
  >
    <path
      d="M17.5 1.67a.83.83 0 0 0-.83.83v1.67H15V2.5a.83.83 0 1 0-1.67 0v.83H6.67V2.5A.83.83 0 0 0 5 2.5v1.67H3.33V2.5a.83.83 0 1 0-1.66 0v15a.83.83 0 0 0 1.66 0v-1.67H5v1.67a.83.83 0 0 0 1.67 0v-.83h6.66v.83a.83.83 0 0 0 1.67 0v-1.67h1.67v1.67a.83.83 0 0 0 1.66 0v-15a.83.83 0 0 0-.83-.83ZM5 14.17H3.33V12.5H5v1.67Zm0-3.34H3.33V9.17H5v1.66ZM5 7.5H3.33V5.83H5V7.5Zm8.33 7.5H6.67v-4.17h6.66V15Zm0-5.83H6.67V5h6.66v4.17Zm3.34 5H15V12.5h1.67v1.67Zm0-3.34H15V9.17h1.67v1.66Zm0-3.33H15V5.83h1.67V7.5Z"
      fill="#5C64ED"
    />
    <path
      d="M17.5 1.67a.83.83 0 0 0-.83.83v1.67H15V2.5a.83.83 0 1 0-1.67 0v.83H6.67V2.5A.83.83 0 0 0 5 2.5v1.67H3.33V2.5a.83.83 0 1 0-1.66 0v15a.83.83 0 0 0 1.66 0v-1.67H5v1.67a.83.83 0 0 0 1.67 0v-.83h6.66v.83a.83.83 0 0 0 1.67 0v-1.67h1.67v1.67a.83.83 0 0 0 1.66 0v-15a.83.83 0 0 0-.83-.83ZM5 14.17H3.33V12.5H5v1.67Zm0-3.34H3.33V9.17H5v1.66ZM5 7.5H3.33V5.83H5V7.5Zm8.33 7.5H6.67v-4.17h6.66V15Zm0-5.83H6.67V5h6.66v4.17Zm3.34 5H15V12.5h1.67v1.67Zm0-3.34H15V9.17h1.67v1.66Zm0-3.33H15V5.83h1.67V7.5Z"
      fill="url(#a)"
    />
    <defs>
      <linearGradient
        id="a"
        x1="10"
        y1="1.67"
        x2="10"
        y2="18.33"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9445EC" />
        <stop offset="1" stopColor="#2782ED" />
      </linearGradient>
    </defs>
  </SvgIcon>
)

NavigationBarFilmIcon.defaultProps = {
  sx: null,
}
